import { useState } from 'react';
import Layout from '../../components/Layout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { clientPortalAPI } from '../../api';
import { useToast } from '../../hooks/useToast';
import { Loader2 } from 'lucide-react';

const METHODS = [
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'text', label: 'Text (SMS)' },
];

export default function ClientMessages() {
  const { success, error: showError } = useToast();
  const [reason, setReason] = useState('');
  const [message, setMessage] = useState('');
  const [contactMethod, setContactMethod] = useState('email');
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!reason.trim() || message.trim().length < 3) {
      showError('Please enter a reason and a short message.');
      return;
    }
    setSending(true);
    try {
      await clientPortalAPI.sendMessage({ reason: reason.trim(), message: message.trim(), contactMethod });
      setReason('');
      setMessage('');
      success('Your message has been sent. The business will get back to you.');
    } catch (err) {
      showError(err.response?.data?.error || err.message || 'Could not send');
    } finally {
      setSending(false);
    }
  };

  return (
    <Layout>
      <div className="bg-[var(--ds-surface-panel)] border-b border-[var(--ds-border-subtle)]">
        <div className="max-w-2xl mx-auto px-6 py-6">
          <h1 className="text-display font-bold text-[var(--ds-text-primary)]">Message us</h1>
          <p className="text-meta text-[var(--ds-text-secondary)] mt-1">
            Send a note to your supplier. They are notified by email.
          </p>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-8">
        <Card>
          <CardContent className="p-6">
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Reason for message</label>
                <input
                  className="w-full rounded-md border border-[var(--ds-border-subtle)] bg-background px-3 py-2 text-sm"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="e.g. Question about invoice"
                  maxLength={100}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Message</label>
                <textarea
                  className="w-full min-h-[140px] rounded-md border border-[var(--ds-border-subtle)] bg-background px-3 py-2 text-sm"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Describe what you need…"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">How should we contact you?</label>
                <select
                  className="w-full rounded-md border border-[var(--ds-border-subtle)] bg-background px-3 py-2 text-sm"
                  value={contactMethod}
                  onChange={(e) => setContactMethod(e.target.value)}
                >
                  {METHODS.map((m) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </select>
              </div>
              <Button type="submit" disabled={sending}>
                {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Send message'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
